<div class="">
    <app-header></app-header>
    <div class="n-body">
        <app-sidebar></app-sidebar>
        <div class="layout-main-container n-panel" [ngClass]="{'n-panel--border-top-left': isSidebarOpen}">
            <div class="layout-main">
                <router-outlet></router-outlet>
            </div>
        </div>
        <div class="layout-mask"></div>
    </div>
</div>